 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Deliver":"Deliver","Employee":"Employee","Payment":"Payment","PaymentMethod":"PaymentMethod","PaymentShare":"PaymentShare","Profile":"Profile","WidgetPayment":"WidgetPayment","BusinessDashboard":"BusinessDashboard","CreateGame~GameDetail~StoreOrder~StoreProduct":"CreateGame~GameDetail~StoreOrder~StoreProduct","CreateGame~Manage-Point":"CreateGame~Manage-Point","CreateGame":"CreateGame","CreatePayment":"CreatePayment","Dashboard":"Dashboard","Gamelist":"Gamelist","Homepage":"Homepage","Login":"Login","Store":"Store","StoreCategory":"StoreCategory","StoreCustomer":"StoreCustomer","StoreList":"StoreList","StoreSetting":"StoreSetting","UpdateBusiness":"UpdateBusiness","GameDetail":"GameDetail","StoreOrder":"StoreOrder","StoreProduct":"StoreProduct","Manage-Point":"Manage-Point"}[chunkId]||chunkId) + "." + {"Deliver":"8305f244","Employee":"20bb5548","Payment":"8c5db5ed","PaymentMethod":"cf36e934","PaymentShare":"cf047703","Profile":"6da5bea6","WidgetPayment":"8d3ef853","chunk-1fb4944c":"24f00347","chunk-25c5bc2d":"5c416172","BusinessDashboard":"eb911438","CreateGame~GameDetail~StoreOrder~StoreProduct":"622ba1b3","CreateGame~Manage-Point":"087aa6c4","CreateGame":"2dc0eca7","CreatePayment":"28f0ec13","Dashboard":"ba7ffa2b","Gamelist":"d8293028","Homepage":"007e26fe","Login":"f604ee5a","Store":"5b340b51","StoreCategory":"70ad353f","StoreCustomer":"b9830e15","StoreList":"05fe5332","StoreSetting":"8a8d088d","UpdateBusiness":"e200af5c","chunk-2d0be0ac":"29a76049","GameDetail":"7066555e","StoreOrder":"04c74770","StoreProduct":"c2e898a3","Manage-Point":"7aa5d59b","chunk-2e9b37a4":"689b1fd5","chunk-ab22a884":"c88fec38","chunk-36b70640":"6a764e91","chunk-5d3dceef":"7f801362","chunk-43cbbb3f":"9d64277b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Deliver":1,"Employee":1,"Payment":1,"PaymentMethod":1,"PaymentShare":1,"Profile":1,"WidgetPayment":1,"chunk-1fb4944c":1,"BusinessDashboard":1,"CreateGame~GameDetail~StoreOrder~StoreProduct":1,"CreateGame~Manage-Point":1,"CreateGame":1,"CreatePayment":1,"Dashboard":1,"Gamelist":1,"Homepage":1,"Login":1,"Store":1,"StoreCategory":1,"StoreCustomer":1,"StoreList":1,"StoreSetting":1,"UpdateBusiness":1,"GameDetail":1,"StoreOrder":1,"StoreProduct":1,"Manage-Point":1,"chunk-ab22a884":1,"chunk-36b70640":1,"chunk-5d3dceef":1,"chunk-43cbbb3f":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Deliver":"Deliver","Employee":"Employee","Payment":"Payment","PaymentMethod":"PaymentMethod","PaymentShare":"PaymentShare","Profile":"Profile","WidgetPayment":"WidgetPayment","BusinessDashboard":"BusinessDashboard","CreateGame~GameDetail~StoreOrder~StoreProduct":"CreateGame~GameDetail~StoreOrder~StoreProduct","CreateGame~Manage-Point":"CreateGame~Manage-Point","CreateGame":"CreateGame","CreatePayment":"CreatePayment","Dashboard":"Dashboard","Gamelist":"Gamelist","Homepage":"Homepage","Login":"Login","Store":"Store","StoreCategory":"StoreCategory","StoreCustomer":"StoreCustomer","StoreList":"StoreList","StoreSetting":"StoreSetting","UpdateBusiness":"UpdateBusiness","GameDetail":"GameDetail","StoreOrder":"StoreOrder","StoreProduct":"StoreProduct","Manage-Point":"Manage-Point"}[chunkId]||chunkId) + "." + {"Deliver":"676f4aa4","Employee":"12e0f591","Payment":"8fe66bb6","PaymentMethod":"90bae96c","PaymentShare":"e4610716","Profile":"4f3792b6","WidgetPayment":"94be4935","chunk-1fb4944c":"5aa0f096","chunk-25c5bc2d":"31d6cfe0","BusinessDashboard":"eea3f51d","CreateGame~GameDetail~StoreOrder~StoreProduct":"d4c8a889","CreateGame~Manage-Point":"a9a356ff","CreateGame":"0b3dc89e","CreatePayment":"5cb67256","Dashboard":"21e9ff6f","Gamelist":"637f300a","Homepage":"55708bd2","Login":"ddb438b2","Store":"af81a52e","StoreCategory":"8ab01d0f","StoreCustomer":"22d6792e","StoreList":"5f7ad897","StoreSetting":"69a72f9d","UpdateBusiness":"34439774","chunk-2d0be0ac":"31d6cfe0","GameDetail":"c22867ce","StoreOrder":"3a02049b","StoreProduct":"0c2281e5","Manage-Point":"05679fb3","chunk-2e9b37a4":"31d6cfe0","chunk-ab22a884":"64460baa","chunk-36b70640":"0757ca2c","chunk-5d3dceef":"024dc0a6","chunk-43cbbb3f":"18c5472c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
